import { useSuspenseRequiredCurrentUser } from 'FrontRoyalAngular';
import { useMemo } from 'react';
import { type WeeklyVoiceLimitState } from '../TutorBotConversation.types';
import { useWeeklyTimeLimitSeconds } from './useVoiceAgentStatsigConfig';

export function useWeeklyVoiceTimeLimitState(): WeeklyVoiceLimitState {
    const {
        tutorBotVoiceAgentSecondsUsedThisWeek,
        tutorBotVoiceAgentWeeklyLimitRefreshTimestamp: refreshTimestamp,
        prefLocale,
    } = useSuspenseRequiredCurrentUser();
    const weeklyTimeLimitSeconds = useWeeklyTimeLimitSeconds();
    return useMemo(() => {
        const refreshDate = new Date(1000 * refreshTimestamp);
        const refreshDayOfWeek = refreshDate.toLocaleDateString(prefLocale, { weekday: 'long' });
        const refreshHour = refreshDate.toLocaleTimeString(prefLocale, {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        });
        // We use the Math.max to round up to 1 whenever 1-59 seconds have been used, but still round down whenever
        // at least 1 minute has been used
        const usedMinutes =
            tutorBotVoiceAgentSecondsUsedThisWeek > 0
                ? Math.max(1, Math.floor(tutorBotVoiceAgentSecondsUsedThisWeek / 60))
                : 0;
        const allowedMinutes = Math.floor(weeklyTimeLimitSeconds / 60);
        const state: WeeklyVoiceLimitState = {
            overTimeLimit: tutorBotVoiceAgentSecondsUsedThisWeek >= weeklyTimeLimitSeconds,
            usedMinutes,
            allowedMinutes,
            refreshHour,
            refreshDayOfWeek,
        };
        return state;
    }, [tutorBotVoiceAgentSecondsUsedThisWeek, refreshTimestamp, weeklyTimeLimitSeconds, prefLocale]);
}
